const citySegment = "/:city([\\w-]+)";

const plSubpages = ["/", "/ceny/", "/oferta/", "/popyt/", "/sprzedane/", "/nowe/"];
const enSubpages = ["/", "/prices/", "/offer/", "/demand/", "/sold/", "/added/"];

const buildLegacyPaths = (prefix: string, subpages: string[]) =>
    subpages.map((subpage) => `${prefix}${citySegment}${subpage}`);

export const LEGACY_CITY_CHART_PATHS = [
    ...buildLegacyPaths("/ceny/mieszkania", plSubpages),
    ...buildLegacyPaths("/ceny/nieruchomosci", plSubpages),
    ...buildLegacyPaths("/ceny/domy", plSubpages),
    ...buildLegacyPaths("/en/prices/flats", enSubpages),
    ...buildLegacyPaths("/en/prices/properties", enSubpages),
    ...buildLegacyPaths("/en/prices/houses", enSubpages)
];
